module.exports = __webpack_public_path__ + "img/gestao_municipal_prata.d7ce739d.png";